import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import AccessoryService from '../../api/services/AccessoryService';

const Accessories = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
    const [accessory, setAccessory] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = accessory.slice(firstIndex, lastIndex);
    const npage = Math.ceil(accessory.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        getAccessory();
    }, []);

    const getAccessory = async () => {
        try {
            let accessory = await AccessoryService.index().json();
            setAccessory(accessory.data);
            setisloading(false);
        } catch (error) {
            console.log(error);
        }

    };
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const deleteAccessory = async (id) => {

        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                let responseData = await AccessoryService.destroy(id).json()
                getAccessory();
                if (responseData.status === 200) {

                }
                swal("Your Accessory has been deleted successfully!", {
                    icon: "success",
                });
            }
        }).catch(() => {
            swal("Your Accessory is safe!");
        });
    }
    return (
        <>
            <MainPagetitle mainTitle="Accessories" pageTitle={'Accessories'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Accessories</h4>
                                        <div>
                                            <Link to={`/admin/add_accessories/`} className="btn btn-primary btn-sm ms-1">+ Add Accessories</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Title</th>
                                                    <th>Price</th>
                                                    <th>MonthPrice</th>
                                                    <th>Inventory</th>
                                                    <th>Image</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><span>{index + 1}</span></td>
                                                        <td>
                                                            <div className="products">

                                                                <div>
                                                                    <h6>{item.title}</h6>

                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td><span>{item.price}</span></td>
                                                        <td><span>{item.per_month}</span></td>
                                                        <td><span>{item.inventory}</span></td>
                                                        <td><img className="img-drop-area" height={item.icon ? 50 : 0} width={item.icon ? 50 : 0} src={imageUrl + "Accessory/" + item.icon} alt='accessories' /></td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/edit_accessories/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Link
                                                                    onClick={() =>
                                                                        deleteAccessory(item.id)
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                                {/* <Button  className="btn btn-danger shadow btn-xs sharp" onClick={() => deleteAccessory(item.id)}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Button> */}
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {accessory.length < lastIndex ? accessory.length : lastIndex}
                                                {" "}of {accessory.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default Accessories;